"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsCreateBatchStepContactsPreview = exports.getIsCreateBatchStepUploadFile = exports.getCreateBatchStep = void 0;

var _ramda = require("ramda");

var _createBatchStep = require("./createBatchStep.reducer");

var _createBatchStep2 = require("./createBatchStep.constants");

var getCreateBatchStepState = function getCreateBatchStepState(state) {
  return state.modules.giftingFlow.ui[_createBatchStep.name];
};

var getCreateBatchStep = (0, _ramda.pipe)(getCreateBatchStepState, (0, _ramda.prop)('step'));
exports.getCreateBatchStep = getCreateBatchStep;
var getIsCreateBatchStepUploadFile = (0, _ramda.pipe)(getCreateBatchStep, (0, _ramda.equals)(_createBatchStep2.CreateBatchStep.FileUpload));
exports.getIsCreateBatchStepUploadFile = getIsCreateBatchStepUploadFile;
var getIsCreateBatchStepContactsPreview = (0, _ramda.pipe)(getCreateBatchStep, (0, _ramda.equals)(_createBatchStep2.CreateBatchStep.ContactsPreview));
exports.getIsCreateBatchStepContactsPreview = getIsCreateBatchStepContactsPreview;